import React, { useState } from 'react';

interface MyComponentProps {
  isActive: any;
  onClickActive: any;
}
const TabSwitch: React.FC<MyComponentProps> = ({
  isActive,
  onClickActive
}) => {

  return (
    <button
      onClick={() => onClickActive(!isActive)}
      className="relative w-[25px] h-12 flex flex-col items-center justify-center cursor-pointer"
    >
      {/* 三条横杆容器 */}
      <div className="relative flex flex-col justify-between">
        {/* 第一条横杆 */}
        <div className={`
          w-[25px] h-3 bg-black rounded-full transition-all duration-300
          origin-center ${isActive ? 'rotate-45 translate-y-[8px]' : ''}
        `} />

        {/* 第二条横杆 - 点击时消失 */}
        <div className={`
          w-[25px] h-3 bg-black rounded-full transition-all duration-200 my-4
          ${isActive ? 'opacity-0 scale-0' : 'opacity-100 scale-100'}
        `} />

        {/* 第三条横杆 */}
        <div className={`
          w-[25px] h-3 bg-black rounded-full transition-all duration-300
          origin-center ${isActive ? '-rotate-45 -translate-y-[6.5px]' : ''}
        `} />
      </div>
    </button>
  );
};

export default TabSwitch;